import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import { getFlowsActionAsync } from '../redux/actions/flowActions'

export const useFlows = () => {
  const { flowsState } = useSelector((state: RootState) => state.flow)
  const dispatch = useDispatch()

  const getFlows = () => {
    dispatch(getFlowsActionAsync())
  }

  return { flowsState, getFlows }
}
